export { default as LeadCaptureForm } from './LeadCaptureForm';
export { LeadCaptureFormWrapper } from './styles/commonStyle';
